import { render, staticRenderFns } from "./Themify.vue?vue&type=template&id=510a0ef0"
import script from "./Themify.vue?vue&type=script&lang=js"
export * from "./Themify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports